<template>
  <div class="auth-screen d-flex justify-content-center align-items-center">
    <form class="auth-card" @submit.prevent="submitLogin">
      <header class="auth-header">
        <h1>WeekToDo</h1>
        <p class="auth-subtitle">用同一组邮箱和密码，即可注册或登录</p>
      </header>

      <p class="auth-tips" aria-label="使用说明">
        <span><strong>新用户</strong> 填好后点下方「注册新账号」</span>
        <span class="auth-tip-sep" aria-hidden="true"></span>
        <span><strong>老用户</strong> 填好后点「登录」</span>
      </p>

      <label>
        邮箱
        <input v-model="email" type="email" autocomplete="username" required class="form-control" />
      </label>
      <label>
        密码
        <div class="password-field">
          <input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            required
            class="form-control"
          />
          <button
            type="button"
            class="password-toggle"
            :aria-label="showPassword ? '隐藏密码' : '显示密码'"
            :aria-pressed="showPassword"
            @click="showPassword = !showPassword"
          >
            <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'" aria-hidden="true"></i>
          </button>
        </div>
      </label>
      <div class="auth-actions">
        <button type="submit" class="btn btn-primary">登录</button>
        <button type="button" class="btn btn-outline-secondary" @click="submitRegister">注册新账号</button>
      </div>
      <p v-if="error" class="auth-error">{{ error }}</p>
    </form>
  </div>
</template>

<script>
const { login, register } = require("../sync/engine");

export default {
  name: "authScreen",
  emits: ["authenticated"],
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      error: "",
    };
  },
  methods: {
    submitLogin() {
      return this.submit(login);
    },
    submitRegister() {
      return this.submit(register);
    },
    async submit(action) {
      this.error = "";
      try {
        await action(this.email, this.password);
        this.$emit("authenticated");
      } catch (error) {
        this.error = error.message || "无法连接服务器";
      }
    },
  },
};
</script>

<style scoped>
.auth-screen {
  min-height: 100vh;
  background:
    radial-gradient(1200px 480px at 50% -10%, rgba(13, 110, 253, 0.08), transparent 60%),
    #f0f3f6;
}

.auth-card {
  width: 380px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 28px;
  background: #fff;
  border: 1px solid rgba(27, 31, 36, 0.08);
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(27, 31, 36, 0.06);
}

.auth-header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #1f2328;
}

.auth-subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.45;
  color: #656d76;
}

.auth-tips {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  font-size: 12.5px;
  line-height: 1.4;
  color: #656d76;
}

.auth-tips strong {
  font-weight: 600;
  color: #1f2328;
}

.auth-tip-sep {
  width: 1px;
  height: 12px;
  background: #d0d7de;
}

.auth-card label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #424a53;
}

.password-field {
  position: relative;
}

.password-field .form-control {
  padding-right: 2.5rem;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 0.35rem;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #656d76;
  line-height: 1;
  cursor: pointer;
}

.password-toggle:hover {
  color: #1f2328;
  background: rgba(27, 31, 36, 0.06);
}

.password-toggle:focus-visible {
  outline: 2px solid rgba(13, 110, 253, 0.45);
  outline-offset: 1px;
}

.auth-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.auth-actions .btn {
  width: 100%;
}

.auth-error {
  color: #cf222e;
  margin: 0;
  font-size: 13px;
}
</style>
